import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
// import { PlusOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Upload from "components/buttons/Upload";
import Input from "components/inputs/Input";
import Select from "components/inputs/Select";
import TextEditor from "components/inputs/TextEditor";
import Fetch from "components/Fetch";
import { StyledModal } from "components/App/styled";

const categoryList = [
  { title: "مقاله", value: "article" },
  { title: "دامپزشکی", value: "vet" },
];
export default function App({ visible, setVisible, data, reload, oldData }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);
  const [images, setImages] = React.useState(
    oldData?.data ? JSON.parse(oldData.images) : []
  );

  React.useEffect(() => {
    oldData && setImages(JSON.parse(oldData?.images) || []);
  }, [visible, oldData]);

  const onSubmit = (data) => {
    const submitData = {
      ...data,
      images: JSON.stringify(images),
      data: JSON.stringify({}),
      category: data?.category ?? "article",
    };
    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/posts", submitData, (res) => {
        console.log("new post response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res.title) {
            message.error(res.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
        setLoading(false);
      });
    } else {
      // update :::::::::
      Fetch.put(`/posts/${oldData.id}`, submitData, (res) => {
        console.log("new post response/ UPDATE", res);
        if (res?.ok || res?.[0]?.id) {
          message.success("با موفقیت آپدیت شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res?.title) {
            message.error(res.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
        setLoading(false);
      });
    }
  };
  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    cleanForm();
    setVisible(false);
  };
  const cleanForm = () => {
    form.setFieldsValue({
      title: null,
      stock: null,
      price: null,
      description: null,
    });
    setImages([]);
  };

  if (oldData) {
    form.setFieldsValue(oldData);
  }

  return (
    <>
      <StyledModal
        getContainer="#root"
        title={oldData ? "به روز رسانی" : " اضافه کردن پست"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
            style={{ width: "100%" }}
            color={colors.blue}
          >
            ثبت
          </Button>,
        ]}
        width={1080}
      >
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl" }}
          //   requiredMark={requiredMark}
          onFinish={onSubmit}
        >
          <ColContainer>
            <Col>
              <Label>عنوان پست :</Label>
              <Form.Item
                name="title"
                rules={[
                  { required: true, message: "لطفا عنوان را وارد کنید!" },
                ]}
              >
                <Input size="large" placeholder="" />
              </Form.Item>
              <Label>دسته بندی :</Label>
              <Form.Item name="category">
                <Select
                  borderradius="2"
                  defaultValue="article"
                  list={categoryList}
                />
              </Form.Item>
              <Label>نویسنده :</Label>
              <Form.Item name="author">
                <Input size="large" placeholder="" style={{ maxWidth: 260 }} />
              </Form.Item>
            </Col>
            <Col style={{ textAlign: "center" }}>
              <Upload
                maxAllowed={20}
                setImage={setImages}
                addedImages={images.length ? images : []}
                key={oldData ? oldData.id + "upload-post" : "upload-post-new"}
                index={() =>
                  setTimeout(() => {
                    return oldData ? oldData.id : 0;
                  }, 100)
                }
              />
              <span>** نسبت ابعاد مناسب، 1*1 می‌باشد.</span>
            </Col>
          </ColContainer>
          <Col style={{ textAlign: "start", width: "100%" }}>
            <Label style={{ fontWeight: "bold", fontSize: 16, marginTop: 24 }}>
              توضیحات :
            </Label>
            <Form.Item name="description">
              <TextEditor
                form={form}
                initialValue={oldData?.data ? oldData?.description : null}
                key={
                  oldData?.id
                    ? oldData?.id + "-description-post"
                    : "description-post"
                }
              />
            </Form.Item>
          </Col>
        </Form>
      </StyledModal>
    </>
  );
}
const ColContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: min(50%, 720px);
  @media (max-width: 480px) {
    min-width: 100%;
  }
`;
const Label = styled.label`
  margin-bottom: 0px;
  display: block;
  color: ${colors.dark};
`;
